var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentNews)?_c('News',{attrs:{"current-news":_vm.currentNews,"has-next-news":_vm.hasNextNews,"total-count":_vm.newsCount},on:{"next":_vm.handleNext}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }